// extracted by mini-css-extract-plugin
export default {"embedString":"EmbedDialog_embedString__qug5n","options":"EmbedDialog_options__5vsmm","toggle":"EmbedDialog_toggle__ZdsOF"};